export type UnknownRecord = Record<string, unknown>

export const getStringValue = (payload: UnknownRecord, key: string): string => {
	const value = payload[key]
	return typeof value === 'string' ? value : ''
}

export const getNumberValue = (payload: UnknownRecord, key: string): number | null | undefined => {
	const value = payload[key]
	if (typeof value === 'number') return value
	if (value === null) return null
	return undefined
}
